import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';
import ReactMarkdown from 'react-markdown';

function FeaturedPost(props) {
  const { post } = props;

  const getImageUrl = (imagePath) => {
    if (!imagePath) return '';
    
    // すでに完全なURLの場合はそのまま返す
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    // 相対パスの場合、環境変数からバックエンドのURLを取得
    if (imagePath.startsWith('/uploads/')) {
      const apiBaseUrl = process.env.REACT_APP_API_URL || '';
      return `${apiBaseUrl}${imagePath}`;
    }
    
    // その他の場合（旧形式のパスなど）
    return imagePath;
  };

  function stripHtml(html) {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  }

  return (
    <Card 
      sx={{ 
        display: "flex", 
        flexDirection: "column", 
        height: 410,
        // ★ width: '100%' を削除し、代わりに最大幅を設定
        maxWidth: '100%',
        // ★ レスポンシブ対応のため、適切な幅制限を追加
        width: { xs: '100%', sm: '100%', md: 'auto' }
      }}
    >
      <CardActionArea
        component={Link}
        to={post.url}
        style={{ height: '100%', textDecoration: 'none', color: 'inherit' }}
      >
        <CardMedia
          component="img"
          sx={{ height: 200 }}
          // image={post.image}
          image={getImageUrl(post.image)}
          alt={post.imageLabel}
        />
        <CardContent>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
            <Typography variant="subtitle1" color="text.secondary">
              {post.date}
            </Typography>
            <Typography variant="subtitle1" color="text.secondary">
              [{post.category}]
            </Typography>
          </Box>

          <Typography component="h2" variant="h5">
            {post.title}
          </Typography>

          <Box sx={{ height: 16 }} />

          <Typography variant="subtitle1">
            {stripHtml(post.description)}
          </Typography>

          <Typography variant="subtitle1" color="primary">
            続きを読む
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

FeaturedPost.propTypes = {
  post: PropTypes.shape({
    date: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageLabel: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired, // urlを追加
  }).isRequired,
};

export default FeaturedPost;